import type { ReactNode } from 'react';
import styles from './Wrapper.module.css';
type Props = {
  children: ReactNode;
  direction?: 'row' | 'column';
  gap?: 'small' | 'medium' | 'large';
  align?: 'start' | 'center';
  justify?: 'start' | 'center' | 'between';
  wrap?: boolean;
};
export function Wrapper({
  children,
  direction = 'row',
  gap = 'medium',
  align = 'center',
  justify = 'start',
  wrap = true,
}: Props) {
  return (
    <div
      className={`${styles.wrapper} ${styles[direction]} ${styles[gap]} ${styles[`align-${align}`]} ${styles[`justify-${justify}`]} ${wrap ? styles.wrap : ''}`}
    >
      {children}
    </div>
  );
}
